import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import RichTextTool from '../../RichTextTool';
import styles from './TextEditorTool.scss';

const TextEditorTool = ({
  style,
  active,
  onToggle,
  className,
  iconClassName,
  tooltip,
  children,
}) => (
  <RichTextTool
    style={style}
    active={active}
    onClick={onToggle}
    className={cx(className, styles.btn)}
    activeClassName={cx(className, styles.btnActive)}
    iconClassName={iconClassName}
    tooltip={tooltip}
  >
    {children}
  </RichTextTool>
);

TextEditorTool.propTypes = {
  style: PropTypes.object,
  active: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  iconClassName: PropTypes.string,
  children: PropTypes.node,
  tooltip: PropTypes.string,
  className: PropTypes.string,
};

export default TextEditorTool;
